@if (auth == true) {
<router-outlet />
}@else if (auth == false) {
<app-error-404 [showButton]="false"></app-error-404>
}